<template>
  <div>
    <!-- if pack -->
    <b class="block font-normal">
      受講開始
      <span class="co-display-8 mx-1 font-bold">{{ dateToMonth(beginsAt) }}</span>月
      <span class="co-display-8 mx-1 font-bold">{{ dateToDay(beginsAt) }}</span>日（{{ dateToWeek(beginsAt) }}）
    </b>

    <TeCommonBalloon
      v-show="showNotification === 'today'"
      class="whitespace-nowrap border-black bg-black align-[8px] text-white"
    >
      <i
        class="fa fa-exclamation-triangle co-display-8 pr-2"
        aria-hidden="true"
      />申込締切（本日締切）<span class="co-display-8 block sm:inline"><span class="co-display-8 mx-1 font-bold">{{ dateToMonth(yesterdayClosesAt) }}</span>月<span class="co-display-8 mx-1 font-bold">{{ dateToDay(yesterdayClosesAt) }}</span>日（{{ dateToWeek(yesterdayClosesAt) }}）<span class="co-display-8 mx-1 font-bold">{{ dateToHours(yesterdayClosesAt) }}</span>時
      </span>
    </TeCommonBalloon>

    <TeCommonBalloon
      v-show="showNotification === 'aLittleLeft'"
      class="whitespace-nowrap border-black bg-black align-[8px] text-white"
    >
      <i
        class="fa fa-clock-o co-display-8 pr-2"
        aria-hidden="true"
      />
      申込締切（残りわずか）
      <span class="block sm:inline">
        <span class="co-display-8 mx-1 font-bold">{{ dateToMonth(yesterdayClosesAt) }}</span>月
        <span class="co-display-8 mx-1 font-bold">{{ dateToDay(yesterdayClosesAt) }}</span>日（{{ dateToWeek(yesterdayClosesAt) }}）
        <span class="co-display-8 mx-1 font-bold">{{ dateToHours(yesterdayClosesAt) }}</span>時
      </span>
    </TeCommonBalloon>

    <span v-show="!showNotification">
      <span>申込締切</span>
      <b class="co-display-8 mx-1 font-bold">{{ dateToMonth(yesterdayClosesAt) }}</b>月
      <b class="co-display-8 mx-1 font-bold">{{ dateToDay(yesterdayClosesAt) }}</b>日（{{ dateToWeek(yesterdayClosesAt) }}）
      <b class="co-display-8 mx-1 font-bold">{{ dateToHours(yesterdayClosesAt) }}</b>時
    </span>

    <div>
      <a
        class="co-btn-primary mt-5"
        href="#apply"
        @click.prevent="scrollTo('apply')"
      >
        今すぐ申し込む
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { dateToYesterday, formatDayOfWeek } from '~/utility/utility'
import TeCommonBalloon from '~/components/Te/TeCommon/Balloon/TeCommonBalloon/TeCommonBalloon.vue'

interface Methods {
  dateToMonth(date: Date | null): number | '-'
  dateToDay(date: Date | null): number | '-'
  dateToHours(date: Date | null): number | '-'
  dateToWeek(date: Date | null): string
}

interface Computed {
  beginsAt: Date | null
  fuelStartsAt: Date | null
  closesAt: Date | null
  yesterdayClosesAt: Date | null
  showNotification: 'today' | 'aLittleLeft' | null
}

interface Props {
  pack: any
}

const options = {
  props: {
    pack: {
      default: null,
    },
  },
  computed: {
    beginsAt() {
      return this.pack ? new Date(this.pack.attributes.begins_at) : null
    },
    fuelStartsAt() {
      return this.pack ? new Date(this.pack.attributes.fuel_starts_at) : null
    },
    closesAt() {
      return this.pack ? new Date(this.pack.attributes.closes_at) : null
    },
    yesterdayClosesAt() {
      if (!this.closesAt) return null
      const newDate = new Date(this.closesAt)
      return dateToYesterday(newDate)
    },
    showNotification() {
      if (!this.closesAt) return null
      const now = new Date()
      const leftDays =
        (this.closesAt.valueOf() - now.valueOf()) / (1000 * 60 * 60 * 24)
      if (leftDays > 0 && leftDays < 1) {
        return 'today'
      } else if (this.fuelStartsAt && this.fuelStartsAt < now) {
        return 'aLittleLeft'
      } else {
        return null
      }
    },
  },
  methods: {
    dateToMonth(date: Date | null) {
      return date ? date.getMonth() + 1 : '-'
    },
    dateToDay(date: Date | null) {
      return date ? date.getDate() : '-'
    },
    dateToHours(date: Date | null) {
      return date ? date.getHours() + 24 : '-'
    },
    dateToWeek(date: Date | null) {
      if (date) {
        const dayOfWeek = formatDayOfWeek(date, false)
        return dayOfWeek as
          | '日'
          | '月'
          | '火'
          | '水'
          | '木'
          | '金'
          | '土'
          | '祝'
      } else {
        return '-'
      }
    },
  },
  components: {
    TeCommonBalloon,
  }
}

export default defineNuxtComponent(options)
</script>
